import React from 'react';

import {RELATION_LEVEL_CAPTIONS} from 'src/modules/manage-entitlements/all-entitlements/presets/constants';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Icon, {Icons} from '@pb/kit-component-icon';


import {
    entitlementDetailsViewLabel,
    entitlementDetailsViewOffsetContainer,
    entitlementDetailsViewToggle,
    entitlementDetailsViewToggleLabel,
} from '../entitlement-details-view.module.styl';

import {GrantList} from './grants-list';


import type {EntitlementRole} from 'src/modules/entitlements/components/drawer/typedef';

type Props = {
    isExpanded: (roleId: string) => boolean,
    onToggleRole: (grantId: string) => void,
    isGrantExpanded: (key: string) => boolean,
    onToggleGrant: (key: string) => void,

    roles: EntitlementRole[],

    onRoleClick: (roleId: string) => void,
    onGrantClick: (grantId: string) => void,
    onResourceClick: (resourceId: string) => void,
};

export const RolesList = (props: Props) => {
    const {
        isExpanded,
        isGrantExpanded,
        onToggleRole,
        onToggleGrant,
        roles,
        onRoleClick,
        onGrantClick,
        onResourceClick,
    } = props;

    return (
        <ul>
            {roles.map(({id: roleId, name, grants, level}, i) => (
                <li key={i}>
                    <div className={entitlementDetailsViewToggle} onClick={() => onToggleRole(roleId)}>
                        <Icon type={isExpanded(roleId) ? Icons.ANGLE_UP : Icons.ANGLE_DOWN}/>
                        <div className={`${entitlementDetailsViewToggleLabel} ${entitlementDetailsViewLabel}`}>
                            <EllipsisTextHint title={name}>
                                <a onClick={() => onRoleClick(roleId)}><b>{name}</b></a>
                            </EllipsisTextHint>
                        </div>
                        {level ? (
                            <b className={entitlementDetailsViewToggleLabel}>
                                ({RELATION_LEVEL_CAPTIONS[level]})
                            </b>
                        ) : null}
                    </div>
                    {isExpanded(roleId) && (
                        <div className={entitlementDetailsViewOffsetContainer}>
                            <b>Grants</b>
                            <GrantList
                                isExpanded={(grantId: string) => isGrantExpanded(`${roleId}-${grantId}`)}
                                onToggleGrant={(grantId: string) => onToggleGrant(`${roleId}-${grantId}`)}
                                grants={grants}
                                onResourceClick={onResourceClick}
                                onGrantClick={onGrantClick}
                            />
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
};
